import React, { useContext } from 'react';
import styles from './LightBox.module.scss';
import { LightBoxContext } from './LightBoxContext';
import { addCustomPathToLink } from '../../functions';

const LightBox = ({ image }) => {
  let { handleLightBox } = useContext(LightBoxContext);

  return (
    <div className={styles.overlay} onClick={(_) => handleLightBox()}>
      <img
        src={addCustomPathToLink(image?.src, true)}
        srcSet={image?.srcSet}
        alt={image?.alt}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      />
      <button className={styles.btnClose} onClick={(_) => handleLightBox()}></button>
    </div>
  );
};

export default LightBox;
